import { LogEntry } from '../interfaces/log-entry.interface';

import { RingBuffer } from './ring-buffer';

export const LogBuffer = new RingBuffer<LogEntry>();
